/**
 * DOM Utilities for KeepSpatial
 */

/**
 * Wait for DOM to be ready
 * @param {Function} callback
 */
export function onDomReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}

/**
 * Observe DOM for dynamically added keep-spatial elements
 * @param {Function} callback - Called with each new element
 * @returns {MutationObserver}
 */
export function observeNewElements(callback) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a keep-spatial element
          if (node.tagName && node.tagName.toLowerCase() === 'keep-spatial') {
            callback(node);
          }
          // Check children of added node
          if (node.querySelectorAll) {
            const elements = node.querySelectorAll('keep-spatial');
            elements.forEach(callback);
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return observer;
}

/**
 * Scan DOM for existing keep-spatial elements
 * @returns {NodeListOf<Element>}
 */
export function scanExistingElements() {
  return document.querySelectorAll('keep-spatial');
}
